const SEO = [
	{
		page: "home",
		description:
			"My website home page",
		keywords: ["Donald", "Donald Flynn", "Donny Flynn", "Donny"],
	},

	{
		page: "about",
		description:
			"My website home page",
		keywords: ["Donald", "Donald Flynn", "Donny Flynn", "Donny"],
	},

	{
		page: "projects",
		description:
			"Overview of my projects",
		keywords: ["Donald", "Donald Flynn", "Donny Flynn", "Donny"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Donald", "Donald Flynn", "Donny Flynn", "Donny"],
	},
];

export default SEO;
